import {SystemBaseApi} from "./SystemBaseApi";
import {Methods} from '@newview/infrastructure';

/**
 * Api
 */
export class ModuleNvdbApi extends SystemBaseApi {
    public get ControllerName(): any {
        return 'module-nvdb'
    }

    public getModuleNvdbList(projectId){
        return this.send({projectId:projectId},"getModuleNvdbList",Methods.GET)
    }



}